/**
 * Display Image Upload Configuration
 *
 * Hardcoded config map keyed by Shopify product ID.
 * Each entry defines the clip-path shape, canvas geometry,
 * file-input selector, and cart property name for a display
 * product that supports custom image upload.
 *
 * clipPath: Polygon — Array of { x, y } points in percentage (0-100)
 *           relative to the product image; emits CSS polygon() and
 *           straight-line canvas clipping.
 *           Shape  — { type: 'shape', css: '…', commands: [{op,…}] }
 *           for curved/complex shapes; the css string is used directly
 *           for CSS clip-path, and commands are replayed on <canvas>.
 *           Supported ops: move, line, arc, bezier, quadratic.
 * canvasSize: Width/height of the compositing canvas (square).
 * inputSelector: CSS selector(s) to find the BOLD file input inside the addons container.
 * cartPropertyName: Line-item property name for the generated composite image.
 * defaultPosition: Initial drag/zoom state.
 *
 * To add a new display product, add an entry keyed by its Shopify product GID.
 */

const DISPLAY_UPLOAD_CONFIGS = {
    // Your image Best mumback panel
    'gid://shopify/Product/4394029187136': {
        clipPath: [
            { x: 21.5, y: 16.5 },
            { x: 75, y: 16.5 },
            { x: 75, y: 54 },
            { x: 21.5, y: 54 },
        ],
        canvasSize: 480,
        inputSelectors: ['input[name="properties[Image 1]"]', 'input[type="file"][name*="Image 1"]'],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
    // YOUR IMAGE Personalised Back Panel
    'gid://shopify/Product/2612350320704': {
        clipPath: [
            { x: 15.5, y: 11 },
            { x: 81.5, y: 11 },
            { x: 81.5, y: 77 },
            { x: 15.5, y: 77 },
        ],
        canvasSize: 480,
        inputSelectors: ['input[name="properties[Image 1]"]', 'input[type="file"][name*="Image 1"]'],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
    // Personalised Black and White Baby Scan Backpanel: polygon(22% 23%, 80% 23%, 80% 68%, 22% 68%)
    'gid://shopify/Product/7587993616558': {
        clipPath: [
            { x: 20, y: 22 },
            { x: 78, y: 22 },
            { x: 78, y: 68 },
            { x: 20, y: 68 },
        ],
        canvasSize: 480,
        inputSelectors: ['input[name="properties[Image 1]"]', 'input[type="file"][name*="Image 1"]'],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
    // Add your own Image Stage Minibuild (for Full Band + Drum Kit)
    'gid://shopify/Product/8913268146350': {
        clipPath: [
            { x: 30, y: 17 },
            { x: 69.5, y: 17 },
            { x: 69.5, y: 57 },
            { x: 30, y: 57 },
        ],
        canvasSize: 480,
        inputSelectors: ['input[name="properties[Image 1]"]', 'input[type="file"][name*="Image 1"]'],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
    // Personalised Photo & Text Backpanel
    'gid://shopify/Product/7954012733614': {
        clipPath: [
            { x: 28, y: 23 },
            { x: 69.5, y: 23 },
            { x: 69.5, y: 62.5 },
            { x: 28, y: 62.5 },
        ],
        canvasSize: 480,
        inputSelectors: ['input[name="properties[Image 1]"]', 'input[type="file"][name*="Image 1"]'],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
    // Graduate Backpanel
    'gid://shopify/Product/9031213023406': {
        clipPath: [
            { x: 20.5, y: 35 },
            { x: 40.5, y: 35 },
            { x: 40.5, y: 60 },
            { x: 20.5, y: 60 },
        ],
        canvasSize: 480,
        inputSelectors: [
            'input[name="properties[Upload Image of Graduate]"]',
            'input[type="file"][name*="Upload Image of Graduate"]',
            'input[name="properties[Upload Your Own Image]"]',
            'input[type="file"][name*="Upload Your Own Image"]',
        ],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
    // Your Image in a Turquoise Heart Back Panel
    'gid://shopify/Product/8177525063854': {
        clipPath: {
            type: 'shape',
            css: 'shape(from 48% 64%, curve to 69% 42% with 51% 60% / 62% 55%, arc to 48% 31% of 1%, arc to 27% 43% of 1%, curve to 48% 64% with 35% 56% / 47% 64%)',
            commands: [
                { op: 'move', x: 48, y: 64 },
                { op: 'bezier', cp1x: 51, cp1y: 60, cp2x: 62, cp2y: 55, x: 69, y: 42 },
                { op: 'arc', x: 48, y: 31, rx: 1, ry: 1 },
                { op: 'arc', x: 27, y: 43, rx: 1, ry: 1 },
                { op: 'bezier', cp1x: 35, cp1y: 56, cp2x: 47, cp2y: 64, x: 48, y: 64 },
            ],
        },
        canvasSize: 480,
        inputSelectors: ['input[name="properties[Image 1]"]', 'input[type="file"][name*="Image 1"]'],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
    // Your Image in a Red Heart Back Panel
    'gid://shopify/Product/8177524342958': {
        clipPath: {
            type: 'shape',
            css: 'shape(from 57% 55%, curve to 65% 47% with 46% 64% / 54% 59%, arc to 49% 31% of 4%, arc to 33% 46% of 1%, curve to 49% 61% with 36% 53% / 49% 62%)',
            commands: [
                { op: 'move', x: 57, y: 55 },
                { op: 'bezier', cp1x: 46, cp1y: 64, cp2x: 54, cp2y: 59, x: 65, y: 47 },
                { op: 'arc', x: 49, y: 31, rx: 4, ry: 4 },
                { op: 'arc', x: 33, y: 46, rx: 1, ry: 1 },
                { op: 'bezier', cp1x: 36, cp1y: 53, cp2x: 49, cp2y: 62, x: 49, y: 61 },
            ],
        },
        canvasSize: 480,
        inputSelectors: ['input[name="properties[Image 1]"]', 'input[type="file"][name*="Image 1"]'],
        cartPropertyName: 'Display Composite Preview',
        defaultPosition: { x: 0, y: 0, scale: 1 },
    },
};

// ── Torso reference shape (kept here so callers can use a single import) ──

export const TORSO_CLIP_PATH = [
    { x: 30, y: 30 },
    { x: 70, y: 30 },
    { x: 78, y: 77 },
    { x: 21, y: 77 },
];

export const TORSO_CANVAS_SIZE = 480;

// ── SVG arc → cubic-bezier conversion (internal) ──────────────────────
// Standard endpoint-to-center arc parameterisation followed by bezier
// approximation (≤ 90° per segment). Used by applyShapeCommandsToCanvas
// to faithfully reproduce CSS shape() arc commands on <canvas>.

function arcToBeziers(x1, y1, x2, y2, rx, ry, phi, largeArc, sweep) {
    if (x1 === x2 && y1 === y2) return [];
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    if (rx === 0 || ry === 0) {
        return [{ cp1x: x1, cp1y: y1, cp2x: x2, cp2y: y2, x: x2, y: y2 }];
    }
    const sinPhi = Math.sin(phi);
    const cosPhi = Math.cos(phi);
    const dx2 = (x1 - x2) / 2;
    const dy2 = (y1 - y2) / 2;
    const x1p = cosPhi * dx2 + sinPhi * dy2;
    const y1p = -sinPhi * dx2 + cosPhi * dy2;
    let rxSq = rx * rx;
    let rySq = ry * ry;
    const x1pSq = x1p * x1p;
    const y1pSq = y1p * y1p;
    const lambda = x1pSq / rxSq + y1pSq / rySq;
    if (lambda > 1) {
        const s = Math.sqrt(lambda);
        rx *= s;
        ry *= s;
        rxSq = rx * rx;
        rySq = ry * ry;
    }
    const num = Math.max(0, rxSq * rySq - rxSq * y1pSq - rySq * x1pSq);
    const den = rxSq * y1pSq + rySq * x1pSq;
    let sq = Math.sqrt(num / den);
    if (largeArc === sweep) sq = -sq;
    const cxp = (sq * rx * y1p) / ry;
    const cyp = (-sq * ry * x1p) / rx;
    const cx = cosPhi * cxp - sinPhi * cyp + (x1 + x2) / 2;
    const cy = sinPhi * cxp + cosPhi * cyp + (y1 + y2) / 2;
    function vecAngle(ux, uy, vx, vy) {
        const dot = ux * vx + uy * vy;
        const len = Math.sqrt(ux * ux + uy * uy) * Math.sqrt(vx * vx + vy * vy);
        let a = Math.acos(Math.max(-1, Math.min(1, dot / len)));
        if (ux * vy - uy * vx < 0) a = -a;
        return a;
    }
    const theta1 = vecAngle(1, 0, (x1p - cxp) / rx, (y1p - cyp) / ry);
    let dtheta = vecAngle((x1p - cxp) / rx, (y1p - cyp) / ry, (-x1p - cxp) / rx, (-y1p - cyp) / ry);
    if (!sweep && dtheta > 0) dtheta -= 2 * Math.PI;
    if (sweep && dtheta < 0) dtheta += 2 * Math.PI;
    const segments = Math.max(1, Math.ceil(Math.abs(dtheta) / (Math.PI / 2)));
    const segAngle = dtheta / segments;
    const alpha = (Math.sin(segAngle) * (Math.sqrt(4 + 3 * Math.pow(Math.tan(segAngle / 2), 2)) - 1)) / 3;
    const result = [];
    for (let i = 0; i < segments; i++) {
        const t1 = theta1 + i * segAngle;
        const t2 = theta1 + (i + 1) * segAngle;
        const cos1 = Math.cos(t1),
            sin1 = Math.sin(t1);
        const cos2 = Math.cos(t2),
            sin2 = Math.sin(t2);
        const ep1x = cosPhi * rx * cos1 - sinPhi * ry * sin1 + cx;
        const ep1y = sinPhi * rx * cos1 + cosPhi * ry * sin1 + cy;
        const ep2x = cosPhi * rx * cos2 - sinPhi * ry * sin2 + cx;
        const ep2y = sinPhi * rx * cos2 + cosPhi * ry * sin2 + cy;
        const d1x = -cosPhi * rx * sin1 - sinPhi * ry * cos1;
        const d1y = -sinPhi * rx * sin1 + cosPhi * ry * cos1;
        const d2x = -cosPhi * rx * sin2 - sinPhi * ry * cos2;
        const d2y = -sinPhi * rx * sin2 + cosPhi * ry * cos2;
        result.push({
            cp1x: ep1x + alpha * d1x,
            cp1y: ep1y + alpha * d1y,
            cp2x: ep2x - alpha * d2x,
            cp2y: ep2y - alpha * d2y,
            x: ep2x,
            y: ep2y,
        });
    }
    return result;
}

// ── Shape() CSS support detection (cached) ──────────────────────────────

let _shapeSupported = null;

function isShapeClipPathSupported() {
    if (_shapeSupported !== null) return _shapeSupported;
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || !CSS.supports) {
        _shapeSupported = false;
        return false;
    }
    _shapeSupported = CSS.supports('clip-path', 'shape(from 0% 0%, line to 100% 100%)');
    return _shapeSupported;
}

// ── Canvas renderer for shape() commands (internal) ─────────────────────
// Replays an array of drawing commands on a 2D canvas context, converting
// percentage coordinates (0-100) to pixels. Supports move, line, arc,
// bezier, and quadratic ops.

function applyShapeCommandsToCanvas(ctx, commands, canvasSize) {
    ctx.beginPath();
    let curX = 0;
    let curY = 0;
    for (const cmd of commands) {
        const px = cmd.x !== undefined ? (cmd.x / 100) * canvasSize : curX;
        const py = cmd.y !== undefined ? (cmd.y / 100) * canvasSize : curY;
        switch (cmd.op) {
            case 'move':
                ctx.moveTo(px, py);
                curX = px;
                curY = py;
                break;
            case 'line':
                ctx.lineTo(px, py);
                curX = px;
                curY = py;
                break;
            case 'arc': {
                const rx = ((cmd.rx || 1) / 100) * canvasSize;
                const ry = ((cmd.ry !== undefined ? cmd.ry : cmd.rx || 1) / 100) * canvasSize;
                const rotation = ((cmd.rotate || 0) * Math.PI) / 180;
                const large = cmd.large ? 1 : 0;
                const sweep = cmd.sweep ? 1 : 0;
                const curves = arcToBeziers(curX, curY, px, py, rx, ry, rotation, large, sweep);
                for (const c of curves) {
                    ctx.bezierCurveTo(c.cp1x, c.cp1y, c.cp2x, c.cp2y, c.x, c.y);
                }
                curX = px;
                curY = py;
                break;
            }
            case 'bezier':
                ctx.bezierCurveTo(
                    (cmd.cp1x / 100) * canvasSize,
                    (cmd.cp1y / 100) * canvasSize,
                    (cmd.cp2x / 100) * canvasSize,
                    (cmd.cp2y / 100) * canvasSize,
                    px,
                    py
                );
                curX = px;
                curY = py;
                break;
            case 'quadratic':
                ctx.quadraticCurveTo((cmd.cpx / 100) * canvasSize, (cmd.cpy / 100) * canvasSize, px, py);
                curX = px;
                curY = py;
                break;
            default:
                break;
        }
    }
    ctx.closePath();
    ctx.clip();
}

// ── Helpers ──────────────────────────────────────────────────────────────

/**
 * Returns the display upload config for a given product ID, or null.
 * For configs using shape() clip paths, returns null when the browser
 * does not support CSS shape() — the overlay should not render.
 */
export function getDisplayUploadConfig(productId) {
    if (!productId) return null;

    const normalized = String(productId).trim();
    const candidates = [normalized];

    // Accept either gid://shopify/Product/<id> or plain numeric IDs.
    if (normalized.startsWith('gid://shopify/Product/')) {
        const numeric = normalized.replace('gid://shopify/Product/', '');
        if (numeric) candidates.push(numeric);
    } else if (/^\d+$/.test(normalized)) {
        candidates.push(`gid://shopify/Product/${normalized}`);
    }

    let config = null;
    for (const key of candidates) {
        if (DISPLAY_UPLOAD_CONFIGS[key]) {
            config = DISPLAY_UPLOAD_CONFIGS[key];
            break;
        }
    }

    if (!config) return null;

    // Curved shapes require CSS shape() support; hide overlay when unavailable.
    if (config.clipPath && !Array.isArray(config.clipPath) && config.clipPath.type === 'shape') {
        if (!isShapeClipPathSupported()) return null;
    }

    return config;
}

/**
 * Quick boolean check: does this product support display image upload?
 */
export function isDisplayUploadProduct(productId) {
    return !!getDisplayUploadConfig(productId);
}

/**
 * Convert a clip-path spec to a CSS clip-path value string.
 *
 * Accepts either:
 *  - Legacy polygon: Array<{ x: number, y: number }>  →  "polygon(…)"
 *  - Shape descriptor: { type: 'shape', css: string }  →  the stored CSS string
 */
export function clipPathToCSS(clipPath) {
    // Legacy polygon format
    if (Array.isArray(clipPath)) {
        if (clipPath.length < 3) return 'none';
        const coords = clipPath.map((p) => `${p.x}% ${p.y}%`).join(', ');
        return `polygon(${coords})`;
    }
    // Shape descriptor — return pre-authored CSS value
    if (clipPath && clipPath.type === 'shape' && clipPath.css) {
        return clipPath.css;
    }
    return 'none';
}

/**
 * Apply a clip-path spec to a canvas 2D context.
 *
 * Accepts either:
 *  - Legacy polygon: Array<{ x: number, y: number }>  (straight-line clip)
 *  - Shape descriptor: { type: 'shape', commands: Array }  (full path replay)
 *
 * All percentage coordinates (0-100) are scaled by canvasSize.
 */
export function applyClipPathToCanvas(ctx, clipPath, canvasSize) {
    // Legacy polygon format
    if (Array.isArray(clipPath)) {
        if (clipPath.length < 3) return;
        ctx.beginPath();
        clipPath.forEach((p, i) => {
            const px = (p.x / 100) * canvasSize;
            const py = (p.y / 100) * canvasSize;
            if (i === 0) ctx.moveTo(px, py);
            else ctx.lineTo(px, py);
        });
        ctx.closePath();
        ctx.clip();
        return;
    }
    // Shape descriptor — replay commands on canvas
    if (clipPath && clipPath.type === 'shape' && Array.isArray(clipPath.commands)) {
        applyShapeCommandsToCanvas(ctx, clipPath.commands, canvasSize);
    }
}

export default DISPLAY_UPLOAD_CONFIGS;
